import { Grid } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useAppSelector } from "app/hooks";
import { FormSection } from "components/FormControls/FormSection";
import { SelectInput } from "components/FormControls/Select/Select";
import { TextInput } from "components/FormControls/TextInput";
import { Toggle } from "components/FormControls/Toggle";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { getCountries } from "reduxState/settings/settings";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontSize: "16px",
      fontWeight: 500,
      color: "#222",
    },
  }),
);

interface Props {
  showAddressDetails: boolean;
}

export const AddressDetails = ({ showAddressDetails }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const countriesList = useAppSelector(getCountries);

  return (
    <FormSection>
      <Grid container rowSpacing={12} columnSpacing={16}>
        <Grid item xs={12}>
          <div className={classes.wrapper}>
            <span className={classes.title}>
              {message({ id: "addressDetails" })}
            </span>
            <Toggle
              name="addressDetails"
              data-test-id="member-address-details"
            />
          </div>
        </Grid>
        {showAddressDetails && (
          <>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "streetName" })}
                name="address.street"
                data-test-id="member-address-street"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "buildingName" })}
                name="address.address1"
                data-test-id="member-address-building"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "flatUnitName" })}
                name="address.address2"
                data-test-id="member-address-flat"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "postalCode" })}
                name="address.postal"
                data-test-id="member-address-postal"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "city" })}
                name="address.city"
                data-test-id="member-address-city"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={message({ id: "stateProvince" })}
                name="address.province"
                data-test-id="member-address-state"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={12}>
              <SelectInput
                items={
                  countriesList
                    ? countriesList.map((country) => ({
                        id: country.code,
                        label: country.name,
                      }))
                    : []
                }
                label={message({ id: "country" })}
                name="address.country"
                data-test-id="member-address-country"
                data-hj-suppress
              />
            </Grid>
          </>
        )}
      </Grid>
    </FormSection>
  );
};
